'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _reducer = require('@marmalade/sdi/lib/quick-quote/reducer');
var _reducer2 = require('@marmalade/fdi/lib/quick-quote/reducer');
var _reducer3 = require('@marmalade/ldi/lib/quote/reducer');
var _reducer4 = require('@marmalade/ndi/lib/quick-quote/reducer');
var _constants = require('./constants');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var hasSuccessfulQuote = function hasSuccessfulQuote(results) {
  var quotes = isSuccessful(results);
  return Object.keys(quotes).some(function (quote) {
    return typeof quotes[quote] !== 'undefined' && quotes[quote];
  });
};
var isSuccessful = function isSuccessful(_ref) {
  var ldi = _ref.ldi,
    sdi = _ref.sdi,
    fdi = _ref.fdi,
    ndi = _ref.ndi;
  return {
    ldi: ldi && (0, _reducer3.quoted)(ldi),
    ndi: typeof ndi !== 'undefined' && ndi !== null,
    sdi: sdi && (0, _reducer.quoted)(sdi),
    fdi: fdi && (0, _reducer2.quoted)(fdi)
  };
};
var productGenerateQuotes = {
  sdi: _reducer.generateQuotes,
  ndi: _reducer4.generateQuotes,
  fdi: _reducer2.generateQuotes,
  ldi: _reducer3.generateQuotes
};
var generateQuotes = function generateQuotes(response) {
  var quoted = isSuccessful(response);
  return Object.keys(quoted).reduce(function (quotes, product) {
    if (quoted[product]) {
      return Object.assign({}, quotes, _defineProperty({}, product, productGenerateQuotes[product](response[product])));
    }
    return quotes;
  }, {});
};
var initialState = {
  fetching: false,
  requestError: false,
  quoteError: false,
  quoted: false,
  params: {
    age: '',
    postcode: '',
    licenceHeld: '',
    licenceType: '',
    regNo: '',
    abiCode: '',
    value: '',
    mainDriver: ''
  },
  quotes: {}
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetching: true,
          requestError: false,
          quoteError: false
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, initialState, {
          fetching: false,
          requestError: true
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        var data = action.payload.data.policy;
        if (action.payload.data.status === 'SUCCESS' && hasSuccessfulQuote(data)) {
          return {
            fetching: false,
            requestError: false,
            quoteError: false,
            quoted: true,
            params: action.meta.params,
            quotes: generateQuotes(data)
          };
        }
        return Object.assign({}, state, {
          fetching: false,
          requestError: false,
          quoteError: true
        });
      }
    case _constants.actionTypes.CLEAR_QUOTES:
      {
        return initialState;
      }
    default:
      return state;
  }
};